import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getRolesAndPernissions = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ROLES_AND_PERMISSION.GET_ROLES_AND_PERMISSION
  );
};

export default getRolesAndPernissions;
